module.exports = __webpack_public_path__ + "assets/icons/corrigo_24px.svg";